<script module lang="ts">
  // Folder context menu (components doc §1 `folderCtx`): open, mark all read, and for custom
  // folders subfolder / rename / delete.
  export interface FolderCtx {
    path: string;
    name: string;
    custom: boolean;
  }
</script>

<script lang="ts">
  import { t } from '$lib/i18n';
  import { store } from '$lib/store';
  import type { MenuAnchor } from '$lib/util/dom';
  import Icon from '../ui/Icon.svelte';
  import Menu from '../ui/Menu.svelte';
  import { deleteFolderFlow, newSubfolderFlow, renameFolderFlow } from './_local';

  let { ctx, anchor, onclose }: { ctx: FolderCtx; anchor: MenuAnchor | null; onclose: () => void } = $props();

  function run(fn: () => unknown) {
    onclose();
    void fn();
  }
</script>

<Menu {anchor} cls="folmenu" label={ctx.name} {onclose}>
  <button type="button" role="menuitem" class="fm-open" onclick={() => run(() => store.openFolder(ctx.path))}><Icon name="folder" size={16} /> {t('openFolder')}</button>
  <button type="button" role="menuitem" class="fm-read" onclick={() => run(() => store.markFolderRead(ctx.path))}><Icon name="check" size={16} /> {t('markAllRead')}</button>
  {#if ctx.custom}
    <div class="menu-sep"></div>
    <button type="button" role="menuitem" class="fm-sub" onclick={() => run(() => newSubfolderFlow(ctx.path, ctx.name))}><Icon name="plus" size={16} /> {t('newSubfolder')}</button>
    <button type="button" role="menuitem" class="fm-rename" onclick={() => run(() => renameFolderFlow(ctx.path, ctx.name))}><Icon name="pen" size={16} /> {t('renameF')}</button>
    <button type="button" role="menuitem" class="fm-del danger-h" onclick={() => run(() => deleteFolderFlow(ctx.path, ctx.name))}><Icon name="trash" size={16} /> {t('delFolder')}</button>
  {/if}
</Menu>

<style>
  /* @css shell/FolderMenu start */
  .menu-sep {
    height: 1px;
    background: var(--border-subtle);
    margin: var(--space-1) 0
  }

  .danger-h:hover {
    color: var(--danger-500)
  }
  /* @css shell/FolderMenu end */
</style>
